import styled from 'styled-components';
import { Card, Grid } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import { IThemeProps } from 'component/theme';

export const StyledEditProfile = styled(Card)`
  padding: 20px;
  box-shadow: 0px 3px 6px #00000029 !important;
  border-radius: 6px !important;
`;

export const StyledAvatar = styled(Avatar)`
  width: 121px !important;
  height: 121px !important;
  svg {
    font-size: 4.5em;
  }
`;

export const HeaderName = styled.div`
  font-size: ${(props) => props.theme.uptimeFontSizes.desktop.fz7}px;
  font-weight: bold;
  text-align: center;
  padding-bottom: 20px;
`;

export const Information = styled.div`
  padding-top: 20px;
  font-size: ${(props) => props.theme.uptimeFontSizes.desktop.fz4}px;
`;

export const InformationDetail = styled(Grid)`
${({theme}: IThemeProps)=> `
  padding: 0;
  @media screen and (min-width: ${theme.breakpoints.sm}) {
    padding: ${theme.uptimeSpace[10]}px;
  }
  @media screen and (min-width: ${theme.breakpoints.lg}) {
    padding: ${theme.uptimeSpace[20]}px;
  }
  .header {
      font-size: ${theme.uptimeFontSizes.desktop.fz7}px;
      font-weight: bold;
      padding-bottom: 10px;
    }
  .label {
    font-weight: bold;
    line-height: 45px;
  }
  .content {
    line-height: 45px;
  }
  .manager {
    padding-top: 25px;
  }
  .copy-button {}
  .copy-icon {
    font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
    color: ${theme.uptimeColors.generalColors.icon.enabled};
  }
  .spacing {
    padding-bottom: 40px;
  }
  `}
`;

export const FormControlContainer = styled(Grid)`
  padding-top: 36px;
  
  .measurement-padding {
    padding-top: 20px;
  }
  .content {
    div {
      font-size: ${(props) => props.theme.uptimeFontSizes.desktop.fz4}px;
      input {
        padding-left: 13px !important;
      }
      fieldset {
        top: -2px;
      }
    }
    .MuiInputBase-fullWidth {
      width: 80%;
    }
    span {
      font-size: ${(props) => props.theme.uptimeFontSizes.desktop.fz4}px;
    }
    .PrivateSwitchBase-root-1 {
      padding: 12px;
    }
    .MuiIconButton-root {
      margin-right: 2px;
    }
    &.measurement {
      padding-top: 5px;
    }
  }
`;

export const StyledDelegationContainer = styled(Grid)`
  ${({theme}: IThemeProps)=> `
    padding-top: 36px;

    .enable-checkbox {
      color: ${theme.uptimeColors.grayScales.darkerGray};  
      padding: ${theme.uptimeSpace[3]}px !important;
    }
  
    .enable-checkbox .MuiSwitch-switchBase{
      top: 6px !important;
      left: 4px !important;
      position: absolute !important;
    }
    .enable-checkbox .MuiSwitch-switchBase.Mui-checked{
      transform: translateX(14px);
    }
    .enable-wrapper{
      display: flex;
      align-item: center;
    }
    .edit-button{
      line-height: ${theme.uptimeLineHeights.desktop.lh1}px;
      margin-left: -${theme.uptimeSpace[1]}px;
      color: ${theme.uptimeColors.mainTheme.secondary};
      background-color: transparent;
      font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
      font-weight: 600;
      display: flex;
      align-items: center;
      padding-bottom: 4px;
      -moz-user-select: none; 
      -ms-user-select: none; 
      -khtml-user-select: none; 
      -webkit-user-select: none; 
      -webkit-touch-callout: none; 
    }
    .edit-button:hover{
      text-decoration: underline;
      cursor: pointer;
    }
    .edit-button.disabled{
      color: ${theme.uptimeColors.grayScales.gray};
    }
    .edit-button.disabled:hover{
      text-decoration: none;
      cursor: unset;
    }
    .edit-button-icon{
      color: ${theme.uptimeColors.mainTheme.secondary}; 
      margin-bottom: ${theme.uptimeSpace[2]}px;
    }
    .edit-button-icon.disabled{
      color: ${theme.uptimeColors.grayScales.gray};
    }
    .MuiIconButton-root.Mui-disabled{
      color: ${theme.uptimeColors.grayScales.darkGray};
    }

    .MuiIconButton-label{
      font-size: 12px;
      font-weight: 600;
    }
    .MuiSvgIcon-root{
      font-size: 14px;
      padding: 0px;
      margin-right: ${theme.uptimeSpace[4]}px;
    }
    .edit-wrapper{
      line-height: 30px;
      margin-left: 24px;
      padding-bottom: 8px;
      display: flex;
      align-items: center;
    }
    .enable-checkbox .MuiSvgIcon-root{
      padding: ${theme.uptimeSpace[0]};
      margin-right: ${theme.uptimeSpace[0]}px;
      font-size: ${theme.uptimeFontSizes.desktop.fz8}px;
    }
    @media screen and (min-width: 600px) and (max-width: 687px), (max-width: 480px) {
      .enable-wrapper{
        margin-left: ${theme.uptimeSpace[6]}%;
      }
    }
    @media screen and (min-width: 960px) and (max-width: 1440px) {
      .enable-wrapper{
        margin-left: ${theme.uptimeSpace[2]}%;
      }
    }
    @media screen and (max-width: 350px){
      .enable-wrapper{
        margin-left: ${theme.uptimeSpace[12]}%;
      }
    }
  `};
` ;

export const StyledDelegationDetails = styled(Grid)`
  ${({theme}: IThemeProps) => `
    line-height: 30px;
    padding-bottom: 4px;
    .detail-title{
      font-weight: 700;
    }
  `}
`;

export const StyledGrid = styled(Grid)`
  ${({ theme }) => `
    .section{
      border: none !important;
    }
  `};
`
